// extracted by mini-css-extract-plugin
export var aboveInput = "_ll-0";
export var actionButton = "_ll-5";
export var actionButtonContainer = "_ll-1";
export var actionIcon = "_ll-6";
export var aiInfoContainer = "_ll-2";
export var attachmentWrapper = "_ll-7";
export var bold = "_ll-3";
export var checkIcon = "_ll-8";
export var clickingRecipientBar = "_ll-11";
export var commentThreadSwitch = "_ll-a";
export var draftImage = "_ll-b";
export var draftImageContainer = "_ll-c";
export var draftImages = "_ll-e";
export var editButton = "_ll-g";
export var editor = "_ll-f";
export var editorContainer = "_ll-y";
export var editorErrorTooltipWrapper = "_ll-9";
export var headerDivider = "_ll-h";
export var icon = "_ll-i";
export var info = "_ll-j";
export var internal = "_ll-n";
export var internalDivider = "_ll-k";
export var internalMessage = "_ll-l";
export var messageInputCard = "_ll-m";
export var messageInputForm = "_ll-o";
export var messageInputFormInternal = "_ll-p";
export var options = "_ll-q";
export var publicMessageCustomer = "_ll-s";
export var publicMessageMerchant = "_ll-r";
export var removeImageButton = "_ll-d";
export var replyButtons = "_ll-t";
export var showSignatureButton = "_ll-u";
export var spinner = "_ll-v";
export var verticalButtonDivider = "_ll-4";
export var visibilitySelector = "_ll-w";
export var warning = "_ll-x";
export var wrappingText = "_ll-z";
export var writingInternalNoteTopBorder = "_ll-10";